import { render, staticRenderFns } from "./ParticipantsCard.vue?vue&type=template&id=4bb8e668&scoped=true&"
import script from "./ParticipantsCard.vue?vue&type=script&lang=js&"
export * from "./ParticipantsCard.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsCard.vue?vue&type=style&index=0&id=4bb8e668&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8e668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
